import React, { useState } from 'react';
import '../css/components/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    setIsMenuOpen(false); // Close mobile menu when a link is clicked
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <nav className="navbar navbar-expand-lg fixed-top">
      <div className="container">
        {/* Brand/Logo */}
        <a className="navbar-brand" href="/" onClick={(e) => {
          e.preventDefault();
          scrollToSection('home');
        }}>
          <img 
            className="nav-icon-img" 
            style={{ height: '80px', width: '80px' }} 
            src="assets/Logo-01.png" 
            alt="Namaste Chai Logo" 
          />
        </a>

        {/* Mobile Menu Toggle */}
        <button 
          className="navbar-toggler" 
          type="button" 
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation Menu */}
        <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
          <div className="navbar-nav ms-auto align-items-lg-center">
            <a className="nav-link text-white mx-2" href="#home" onClick={(e) => {
              e.preventDefault();
              scrollToSection('home');
            }}>Home</a>
            <a className="nav-link text-white mx-2" href="#about" onClick={(e) => {
              e.preventDefault();
              scrollToSection('about');
            }}>About Us</a>
            <a className="nav-link text-white mx-2" href="#franchise" onClick={(e) => {
              e.preventDefault();
              scrollToSection('franchise');
            }}>Franchise</a>
            <a className="nav-link text-white mx-2" href="#distributorship" onClick={(e) => {
              e.preventDefault();
              scrollToSection('distributorship');
            }}>Distributorship</a>
            <button 
              className="btn btn-light ms-lg-3 mt-2 mt-lg-0" 
              style={{ color: 'brown', borderRadius: '14px', fontWeight: 'bold' }}
              onClick={() => scrollToSection('Apply-now')}
            >
              Apply Now
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;